import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/home/grade/gaoxin.png'
import _imports_1 from '@/assets/home/grade/xiaojuren.png'
import _imports_2 from '@/assets/home/grade/yidengjiang.png'
import _imports_3 from '@/assets/home/grade/kexue.png'
import _imports_4 from '@/assets/home/zs/lianxidian.png'
import _imports_5 from '@/assets/home/zs/shuangshi.png'
import _imports_6 from '@/assets/home/zs/shixunjidi.png'


const _hoisted_1 = { class: "fullpage" }
const _hoisted_2 = { class: "fp-item fubg3" }
const _hoisted_3 = { class: "fp-item-cont" }

import { onMounted } from 'vue';
import { useHead } from '@vueuse/head'

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

useHead({
      title: '北京大象科技有限公司官网',
      meta: [
        { name: 'description', content: '北京大象科技有限公司成立于2013年，业务范围包括轨道交通、低空技术、应急安全等领域。通过数字化沉浸式解决方案赋能轨道、应急、低空用户的技术验证、场景推演与人才培养，提升行业安全及效率'},
        { name: 'keywords', content:"轨道运营、地铁、低空、应急、培训、竞赛、实训基地、北京大象、大象科技、北京大象科技有限公司、北京大象科技有限公司官网"}
      ]
    })
    // const optionList = [
    //   {label:'',value:'@/assets/home/诚信经营示范等级证书.png'}
    //   {label:'',value:'@/assets/home/诚信经营示范等级证书.png'}
    //   {label:'',value:'@/assets/home/诚信经营示范等级证书.png'}
    //   {label:'',value:'@/assets/home/诚信经营示范等级证书.png'}
    // ]
    onMounted(()=>{
      var element = document.getElementById('myElement');
      element.scrollTop = 0;
    })

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"fp-item fubg1\" data-v-570904de><div class=\"fp-item-cont\" data-v-570904de><div class=\"slogan\" data-v-570904de><h3 data-v-570904de>大象科技</h3><span data-v-570904de>数字化仿真系统和服务供应商</span></div></div></div><div class=\"fp-item fubg2\" data-v-570904de><div class=\"fp-item-cont\" data-v-570904de><div class=\"fenleititle\" style=\"visibility:hidden;\" data-v-570904de>公司简介</div><div class=\"gy_content\" data-v-570904de><div class=\"aboutus\" style=\"visibility:hidden;\" data-v-570904de><p class=\"article\" data-v-570904de>北京大象科技有限公司成立于2013年，是国家高新技术企业、国家级专精特新&quot;小巨人&quot;企业。大象科技拥有交通运输部职业建设联系点、教育部双师型教师培训基地、北京市丰台区职业技能培训学院实训基地等资质。</p><p class=\"article\" data-v-570904de>公司业务范围包括轨道交通、低空技术、应急安全等领域。通过数字化沉浸式解决方案赋能轨道、应急、低空用户的技术验证、场景推演与人才培养，提升行业安全及效率。</p><p class=\"article\" data-v-570904de>公司拥有一支团结、奋进、精研的高水平技术团队作为整个公司技术创新的强力引擎，承担复杂技术难题攻关任务，持续输出高品质技术成果。获得多个科学进步奖。</p></div></div></div></div>", 2)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "fenleititle",
          style: {"visibility":"hidden"}
        }, "公司资质", -1)),
        _createVNode(_component_el_carousel, {
          class: "carousel1",
          "indicator-position": "outside",
          height: "380px",
          autoplay: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_carousel_item, null, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("div", {
                  class: "certificate",
                  style: {"visibility":"hidden"}
                }, [
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_0 }),
                    _createElementVNode("span", null, "高新技术企业证书")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_1 }),
                    _createElementVNode("span", null, "国家级专精特新\"小巨人\"企业")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_2 }),
                    _createElementVNode("span", null, "城市轨道交通科学进步一等奖")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_3 }),
                    _createElementVNode("span", null, "北京市轨道交通学会科学技术进步奖二等奖")
                  ])
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"certificate_mobile\" data-v-570904de><div class=\"detailpic\" data-v-570904de><img src=\"" + _imports_0 + "\" data-v-570904de><span data-v-570904de>高新技术企业证书</span></div><div class=\"detailpic\" data-v-570904de><img src=\"" + _imports_1 + "\" data-v-570904de><span data-v-570904de>国家级专精特新&quot;小巨人&quot;企业</span></div><div class=\"detailpic\" data-v-570904de><img src=\"" + _imports_2 + "\" data-v-570904de><span data-v-570904de>城市轨道交通科学进步一等奖</span></div><div class=\"detailpic\" data-v-570904de><img src=\"" + _imports_3 + "\" data-v-570904de><span data-v-570904de>北京市轨道交通学会科学技术进步奖二等奖</span></div></div>", 1)),
        _createVNode(_component_el_carousel, {
          class: "carousel2",
          "indicator-position": "outside",
          height: "300px",
          autoplay: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_carousel_item, null, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("div", {
                  class: "certificate2",
                  style: {"visibility":"hidden"}
                }, [
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_4 }),
                    _createElementVNode("span", null, "交通运输部职业建设联系点")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_5 }),
                    _createElementVNode("span", null, "教育部双师型教师培训基地")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_6 }),
                    _createElementVNode("span", null, "北京市丰台区职业技能培训学院实训基地")
                  ])
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"certificate_mobile\" style=\"margin-top:50px;\" data-v-570904de><div class=\"detailpic\" data-v-570904de><img src=\"" + _imports_4 + "\" data-v-570904de><span data-v-570904de>交通运输部职业建设联系点</span></div><div class=\"detailpic\" data-v-570904de><img src=\"" + _imports_5 + "\" data-v-570904de><span data-v-570904de>教育部双师型教师培训基地</span></div><div class=\"detailpic\" data-v-570904de><img src=\"" + _imports_6 + "\" data-v-570904de><span data-v-570904de>北京市丰台区职业技能培训学院实训基地</span></div></div>", 1))
      ])
    ])
  ]))
}
}

})